import styled from '@emotion/styled';
import { isAeProduct } from 'productLine';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  > header {
    display: ${isAeProduct ? 'none' : 'block'};
    position: sticky;
    top: var(--page-sticky-top);
    margin-bottom: 16px;
    z-index: 2;
  }
  > .ant-alert {
    padding: 4px 15px;
    margin: -8px 0 8px;
  }
`;

export const Center = styled.div`
  flex: 1 0 0;
  height: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h3`
  justify-content: space-between;
`;

export const List = styled.ul`
  margin: 0;
  padding: 18px 25px;
  list-style: none;
  > li {
    margin-bottom: 25px;
  }
`;
